import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { DataSourcesById } from "../types";
import {
  isDataSourceStateFetching,
  receiveDataSource,
  receiveDataSources,
  receiveDataSourcesState,
  updateDataSourceState,
} from "../actionCreators";
import dataSourceStateReducer from "./dataSourceStateReducer";
import { DataSourceModel } from "../../../requests/dataSources/types";

const initialState: DataSourcesById = {};

const dataSourcesByIdReducer = reducer(
  initialState,
  on(receiveDataSources, (state, { payload: { dataSources } }) => {
    const dataSourceEntries = dataSources.map((dataSource) => [
      dataSource.id,
      {
        state: state[Number(dataSource.id)]?.state ?? undefined,
        data: dataSource,
      },
    ]);
    return Object.fromEntries(dataSourceEntries);
  }),
  on(receiveDataSource, (state, { payload: { dataSource } }) => {
    const dataSourceForId = state[Number(dataSource.id)];
    if (dataSourceForId) {
      // eslint-disable-next-line no-param-reassign
      state[Number(dataSource.id)].data = dataSource;
    } else {
      // eslint-disable-next-line no-param-reassign
      state[Number(dataSource.id)] = {
        state: undefined,
        data: dataSource,
      };
    }
  }),
  on(receiveDataSourcesState, (state, { payload: { dataSourcesState } }) => {
    Object.keys(dataSourcesState).forEach((dataSourceId) => {
      const dataSourceForId = state[Number(dataSourceId)];
      if (dataSourceForId) {
        // eslint-disable-next-line no-param-reassign
        state[Number(dataSourceId)].state = {
          data: dataSourcesState[Number(dataSourceId)],
          isFetching: false,
        };
      } else {
        // eslint-disable-next-line no-param-reassign
        state[Number(dataSourceId)] = {
          state: {
            data: dataSourcesState[Number(dataSourceId)],
            isFetching: false,
          },
          data: {} as DataSourceModel,
        };
      }
    });
  }),
  on(
    ...union(updateDataSourceState, isDataSourceStateFetching),
    (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state[Number(action.payload.dataSourceId)].state = dataSourceStateReducer(
        state[Number(action.payload.dataSourceId)].state,
        action
      );
    }
  )
);

export default dataSourcesByIdReducer;
